// JsFromRoutes CacheKey f4cc4bcc7a119fbbb9f404f9f47c85f5
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/:org_nano_id/integrations'),
}
